/**
 * @Deprecated In the code always use BREAKPOINTS_FROM, matchMediaFrom, breakpointOf.
 *             In the CSS always use cg-from-X.
 * BREAKPOINTS_TO
 * Assuming that XS=600:
 * to(XS) -> (max-width: 599)
 */
export var BREAKPOINTS = {
    XS: 599,
    S: 1023,
    M: 1439,
    L: 1599,
    XL: 1919,
    XXL: 2560,
};
/**
 * from(XS) -> (min-width: 0)
 */
export var BREAKPOINTS_FROM = {
    XS: 0,
    S: 600,
    M: 1024,
    L: 1440,
    XL: 1600,
    XXL: 1920,
};
export var matchMediaFrom = function (b) {
    return "(min-width: ".concat(BREAKPOINTS_FROM[b], "px)");
};
export var breakpointOf = function (width) {
    // I hope that this is how
    var widthNum = parseFloat(width);
    var breakpoint = 'XS';
    for (var _i = 0, _a = Object.keys(BREAKPOINTS_FROM); _i < _a.length; _i++) {
        var k = _a[_i];
        if (widthNum >= BREAKPOINTS_FROM[k]) {
            breakpoint = k;
        }
        else {
            break;
        }
    }
    return breakpoint;
};
